import FaqCategory from './FaqCategory';

export default FaqCategory;
